<template>
    <div class="funItem">
        <div class="itemTitle">{{ title }}</div>
        <div class="maxBnner">
            <el-carousel indicator-position="none" trigger="click" :height="height + 'px'">
                <el-carousel-item v-for="item in list" :key="item.id">
                    <div :style="{ backgroundImage: `url('${item.bg_url}')` }" class="bannerItem">
                        <img :src="item.banner || item.cover" alt="" />
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="bottomText">{{ list[0].title }}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            height: 700,
        }
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        list: {
            type: Array,
            default: (() => [])
        }
    },
    computed: {

    },
    created() {
        let maxWidth = window.innerWidth
        if (maxWidth < 1200) {
            this.height = maxWidth * (7 / 12)
        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.funItem {
    margin-top: 0px;
    margin-bottom: 116px;

    .itemTitle {
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        width: 1200px;
        margin: auto;
    }

    .maxBnner {
        width: 100%;
        height: 700px;
        margin-top: 40px;

        .bannerItem {
            width: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            img {
                width: 1200px;
                height: auto;
                object-fit: cover;
                display: block;
                margin: auto;
            }
        }
    }

    .bottomText {
        width: 1200px;
        margin: auto;
        font-size: 21px;
        color: #000000;
        margin-top: 40px;
    }
}

::v-deep .el-carousel__arrow--left {
    display: none !important;
}

::v-deep .el-carousel__arrow--right {
    display: none !important;
}

@media screen and (max-width:1200px) {
    .funItem {
        margin-top: 20px;

        .itemTitle {
            font-weight: 500;
            font-size: 18px;
            color: #000000;
            width: 100%;
            margin: auto;
        }

        .maxBnner {
            width: 100%;
            height: auto;
            margin-top: 40px;

            .bannerItem {
                width: 100%;
                height: auto;

                img {
                    width: 100%;
                    height: auto;
                    object-fit: cover;
                    display: block;
                    margin: auto;
                }
            }
        }

        .bottomText {
            width: 100%;
            margin: auto;
            font-size: 14px;
            color: #000000;
            margin-top: 20px;
        }
    }
}
</style>